export var EMPTY_ABOUT = {
    block1: {
        kicker: "",
        title: "",
        description: "",
        highlights: [
            { title: "", description: "" },
            { title: "", description: "" },
            { title: "", description: "" },
        ],
        meta: [
            { label: "", value: "", description: "" },
            { label: "", value: "", description: "" },
            { label: "", value: "", description: "" },
            { label: "", value: "", description: "" },
        ],
    },
    block2: { kicker: "", title: "", description: "", imageUrl: null },
    block3: { kicker: "", title: "", description: "", imageUrl: null },
    block4: { kicker: "", title: "", description: "", imageUrl: null },
    block5: {
        title: "",
        description: "",
        items: [
            { title: "", description: "", imageUrl: null },
            { title: "", description: "", imageUrl: null },
            { title: "", description: "", imageUrl: null },
        ],
    },
};
export var SINGLE_IMAGE_BLOCK_NUMBER = {
    block2: 2,
    block3: 3,
    block4: 4,
};
